<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p style="text-align: center;">To Thembisa and Gerhard</p><br/>
<p style="text-align: center;">Love does not fear substantial anarchy, But vividly expresses obligation</p>
<p style="text-align: center;">With movement and in spontaneity.</p>
<p style="text-align: center;">W. H. Auden, <em>For the Time Being</em></p> <br/>
<p style="text-align: center;">To Elaine and Michael</p><br/>
<p style="text-align: center;">Love knows of no somatic tyranny;</p>
<p style="text-align: center;">For homes are built for Love’s accommodation</p>
<p style="text-align: center;">By bodies from the void they occupy</p>
<p style="text-align: center;">W. H. Auden, <em>For the Time Being</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?e1ffbc0a